module.exports = __webpack_public_path__ + "media/images/overview-hodzzy-cc85f12e2dac926170f9669032921723.png";